import { render, staticRenderFns } from "./PdfViewer.vue?vue&type=template&id=2540c087&scoped=true&lang=pug&"
import script from "./PdfViewer.vue?vue&type=script&lang=ts&"
export * from "./PdfViewer.vue?vue&type=script&lang=ts&"
import style0 from "./PdfViewer.vue?vue&type=style&index=0&id=2540c087&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2540c087",
  null
  
)

export default component.exports